var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-footer',{staticClass:"footer",staticStyle:{"height":"30px"}},[_c('img',{staticClass:"LoginBanner",attrs:{"src":require("@/assets/LOGOwithe128.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }